import { Navigate } from "react-router-dom";

export const ProtectedRoutes = (props) => {
  const companyKey = sessionStorage.getItem("company-key");
  const hasToken = Boolean(sessionStorage.getItem("token"));
  const hasCompanyKey = Boolean(companyKey && companyKey !== "null" && companyKey !== "undefined");

  return hasToken || (props.allowCompanyKey && hasCompanyKey) ? props.route : <Navigate replace to={"/"} />;
};
